import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { IconButton } from '@/@bothrs-ui/web/components/primitives/icon-button/IconButton'
import { breakpoints } from '@/config/layout'
import { mixpanel } from '@/mixpanel'

import type { FC } from 'react'
export const TimelineMobileActionButton: FC = () => {
  const navigate = useNavigate()
  // Interaction Methods
  // ------------------------------------------------------------------------- /
  const handleTimelineAction = () => {
    mixpanel.track('timeline_action_click')
    navigate('/appointment/book')
  }

  // Render
  // ------------------------------------------------------------------------- /
  return (
    <>
      <StFloatingButton
        icon={['fal', 'calendar-plus']}
        size='large'
        buttonSize={48}
        variant={'Primary'}
        borderRadius={4}
        onClick={handleTimelineAction}
      />
    </>
  )
}

const StFloatingButton = styled(IconButton)<{
  buttonSize: number
  borderRadius: number
}>`
  position: fixed;
  right: ${({ theme }) => theme.UI.Spacing.Space6}px;
  bottom: ${({ theme }) => theme.UI.Spacing.Space4 + 80}px;

  margin-bottom: var(--safe-area-inset-bottom);

  @media ${breakpoints.fromS} {
    display: none;
  }

  z-index: 1000;

  width: ${({ buttonSize }) => buttonSize}px;
  height: ${({ buttonSize }) => buttonSize}px;
  border-radius: ${({ borderRadius }) => borderRadius}px;

  background-color: ${({ color }) => color};

  color: ${({ theme }) => theme.Colors.Neutrals.Lightest};
`
